

define(['angular'], function (angular) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('beaver.level', []).factory('$logLevel', function () {

        return {
            INFO: 'info',
            DEBUG: 'debug',
            ERROR: 'error',
            WARN: 'warn',
            ALERT: 'alert'
        };
    }).factory('$consoleLogLevel', function () {

        return {
            info: 'info',
            debug: 'debug',
            error: 'error',
            warn: 'warn',
            alert: 'info'
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-beaver/dist/level.js
// module id = ./components/xo-beaver/dist/level.js
// module chunks = 1